export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-03_EN.dde6773c.png";